import { render } from "./CardEdit.vue?vue&type=template&id=ab5dc922"
import script from "./CardEdit.vue?vue&type=script&lang=js"
export * from "./CardEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__